import React from 'react';
import { DataTable, SectionHeader, StatusPill } from '../components';

export function OrdersPage({ rows }) {
  const total = (rows.orders || []).reduce((s, o) => s + (o.status === 'paid' ? (o.amount || 0) : 0), 0);
  return (
    <div>
      <SectionHeader
        title="Orders"
        subtitle={`${rows.orders?.length || 0} transactions · €${total.toFixed(2)} captured`}
      />
      <DataTable
        testid="dash-orders-table"
        rows={rows.orders}
        emptyText="No orders yet."
        columns={[
          { key: 'ref',           label: 'Ref', nowrap: true },
          { key: 'customer_name', label: 'Customer' },
          { key: 'product_name',  label: 'Item' },
          { key: 'amount',        label: 'Amount', nowrap: true,
            render: r => `${r.currency || '€'}${Number(r.amount || 0).toFixed(2)}` },
          { key: 'status',        label: 'Status',
            render: r => <StatusPill value={r.status} /> },
          { key: 'placed_at',     label: 'Placed', nowrap: true,
            render: r => (r.placed_at || '').slice(0, 10) },
        ]}
      />
    </div>
  );
}
